<template>
  <div class="radish-detail-main">
    <div v-if="ready" v-loading="loading" class="radish-detail-wapper">
      <div class="radish-detail-actions" style="text-align: right">
        <span class="radish-btn-text percent" @click="phoneToWx">微信=手机</span>
        <el-dropdown v-if="type != 'left'" trigger="click">
          <el-button type="primary" size="mini" round>
            人选操作 <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item> <div @click="uploadCv">上传简历</div> </el-dropdown-item>
            <el-dropdown-item> <div @click="uploadReport">上传推荐报告</div> </el-dropdown-item>
            <el-dropdown-item> <div @click="uploadHuimian">上传会面记录</div> </el-dropdown-item>
            <el-dropdown-item> <div @click="genRepo">生成推荐报告</div> </el-dropdown-item>
            <el-dropdown-item> <div @click="showIntoProject">加入项目</div> </el-dropdown-item>
            <template v-if="radish['手机']">
              <el-dropdown-item> <div @click="showRecommend">推荐</div> </el-dropdown-item>
            </template>
            <el-dropdown-item> <div @click="showIntoFav">加入收藏夹</div> </el-dropdown-item>
            <el-dropdown-item> <div @click="showRadishPortrait">人才画像</div> </el-dropdown-item>
            <el-dropdown-item> <div @click="orderBasic">排序</div> </el-dropdown-item>
            <el-dropdown-item v-if="type == 'small'">
              <router-link :to="'/radish-detail/' + radish._id" style="color:#606266">跳转全页</router-link>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button v-if="type != 'left'" round size="mini" type="primary" @click.stop="showOchart"
          >查看Ochart</el-button
        >
        <el-button round size="mini" type="primary" @click="showScore">口碑打分</el-button>
        <el-button v-show="isSaveShow" round size="mini" type="primary" @click="save">保存</el-button>
      </div>
      <div class="radish-detail-body">
        <el-alert
          v-if="radish.progress"
          :title="`人选在项目 ${radish.progress.text} 已${radish.progress.type}`"
          :type="radish.progress.type === 'offer' ? 'warning' : 'error'"
        ></el-alert>
        <div class="radish-detail-basic">
          <div class="radish-box">
            <div class="radish-box-content">
              <template v-for="(f, fk) in basicOrder">
                <div
                  v-if="fieldsBasic[f] && fieldsBasic[f].label == '公司'"
                  :title="`公司:${company}`"
                  class="form-item form-item-inline"
                  style="width: 24%;"
                >
                  <el-autocomplete
                    v-model="company"
                    class="inline-input"
                    size="mini"
                    :fetch-suggestions="searchCompany"
                    placeholder="公司"
                    :trigger-on-focus="false"
                  ></el-autocomplete>
                </div>
                <div
                  v-else-if="fieldsBasic[f] && fieldsBasic[f].label == '部门'"
                  :title="`部门:${department}`"
                  class="form-item form-item-inline"
                  style="width: 24%;"
                >
                  <el-autocomplete
                    v-model="department"
                    class="inline-input"
                    size="mini"
                    :fetch-suggestions="searchDepartment"
                    placeholder="部门"
                    :trigger-on-focus="false"
                  ></el-autocomplete>
                </div>
                <template v-else-if="fieldsBasic[f]">
                  <formItem
                    :key="fieldsBasic[f].label"
                    :type="fieldsBasic[f].type"
                    :is-inline="true"
                    :is-required="fieldsBasic[f].isRequired"
                    :width="fieldsBasic[f].width"
                    label-width="0"
                    :label="fieldsBasic[f].label"
                    :display-label="fieldsBasic[f].displayLabel"
                    :no-label="true"
                    :options="fieldsBasic[f].options"
                    :content="formData[fieldsBasic[f].label]"
                    :handle-data-change="handleItemChange"
                    :handle-focus="handleFocus"
                    :remove-tag="handleRemoveTag"
                    :handle-blur="handleBlur"
                  />
                  <div v-if="fieldsBasic[f].label == '手机' && dupData.id" :key="fk + 'd'" class="radish-dup">
                    <i class="el-icon-warning">候选人已存在:</i>&nbsp;
                    <span class="radish-link" @click="showRadish({ id: dupData.id, name: dupData['姓名'] })">
                      {{ dupData['姓名'] }}
                    </span>
                    <span>{{ (dupData['公司'] || '-') + ' ' + (dupData['部门'] || '-') }}</span>
                    <div v-show="!sending">
                      <el-button round size="mini" @click="showDiff"> 进入对比 </el-button>
                      <el-button round size="mini" @click="delOld">合并并放弃重复数据</el-button>
                      <el-button round size="mini" @click="giveUp">合并并放弃本条数据</el-button>
                    </div>
                  </div>
                </template>
              </template>
              <div class="form-item">
                <el-popover v-model="popperVisibleExp" placement="top" width="740" trigger="click">
                  <workExp v-if="ready" ref="workExp" :radish="radish" :on-close="onCloseWorkexp"></workExp>
                  <el-button slot="reference" size="mini" type="primary" plain>任职经历</el-button>
                </el-popover>
              </div>
              <div v-if="recommendYeji.length > 0" class="form-item">
                <el-button size="mini" type="primary" plain @click="showRecommendYeji">建议业绩</el-button>
              </div>
              <div v-if="radish['投资案例'] && radish['投资案例'].length > 0" class="form-item">
                <el-button size="mini" type="primary" plain @click="showInvestmentCase">投资案例</el-button>
              </div>
              <fundList
                :rid="id"
                :name="radish['姓名']"
                :main-funds="mainFunds"
                :duration="radish['任职期']"
                :scale="radish['规模']"
                :subtitle="`基金总规模:${radish['基金总规模'] || '--'} 投资年限:${radish['投资年限'] || '--'}`"
              />
              <div class="form-item">
                <el-popover v-model="popperVisibleMoney" placement="top" width="800" trigger="click">
                  <div class="radish-box">
                    <div class="radish-box-content">
                      <table>
                        <tr>
                          <th style="width:40px">年份</th>
                          <th style="width:100px">月固薪(万)</th>
                          <th style="width:100px">发放月数</th>
                          <th style="width:100px">年固薪(万)</th>
                          <th style="width:180px">奖金对应几个月固薪</th>
                          <th style="width:160px">奖金具体数字(万)</th>
                          <th style="width:100px">全薪(万)</th>
                        </tr>
                        <tr v-for="year in years" :key="year">
                          <td>{{ year }}</td>
                          <td>
                            <el-input
                              v-model="formData.money[year]['月固']"
                              size="mini"
                              placeholder="月固(万)"
                              @input="moneyInput(year)"
                            />
                          </td>
                          <td>
                            <el-input
                              v-model="formData.money[year]['月份']"
                              size="mini"
                              placeholder="月数"
                              @input="moneyInput(year)"
                            />
                          </td>
                          <td>
                            <el-input
                              v-model="formData.money[year]['固薪']"
                              size="mini"
                              placeholder="年固(万)"
                              :disabled="!!(formData.money[year]['月固'] && formData.money[year]['月份'])"
                              @input="moneyInput(year)"
                            />
                          </td>
                          <td>
                            <el-input
                              v-model="formData.money[year]['奖金月数']"
                              size="mini"
                              placeholder="月数"
                              @input="moneyInput(year)"
                            />
                          </td>
                          <td>
                            <el-input
                              v-model="formData.money[year]['奖金']"
                              size="mini"
                              placeholder="奖金(万)"
                              :disabled="!!(formData.money[year]['月固'] && formData.money[year]['奖金月数'])"
                              @input="moneyInput(year)"
                            />
                          </td>
                          <td>
                            <el-input
                              v-model="formData.money[year]['全薪']"
                              size="mini"
                              placeholder="全薪(万)"
                              :disabled="!!(formData.money[year]['固薪'] && formData.money[year]['奖金'])"
                            />
                          </td>
                        </tr>
                      </table>

                      <div>个人奖金情况（不与部门职能模块联动）:</div>
                      <formItem
                        type="textarea"
                        :is-inline="true"
                        width="100%"
                        label-width="0"
                        label="奖金"
                        :no-label="true"
                        :content="formData['奖金']"
                        :handle-data-change="handleItemChange"
                      />
                      <bonusSchemes
                        v-if="formData['公司']"
                        ref="bonusSchemes"
                        :company="formData['公司']"
                        :department="formData['部门']"
                        :cates="formData['职能模块']"
                      />
                      <div v-else>奖金机制:请先填写公司和职能模块</div>
                    </div>
                  </div>
                  <el-button slot="reference" size="mini" type="primary" plain>人选薪酬</el-button>
                </el-popover>
              </div>
              <div class="form-item">
                <el-popover v-model="popperVisibleQi" placement="top" width="400" trigger="click">
                  <formItem
                    v-for="(f, fk) in fieldsQi"
                    :key="fieldsQi[fk].label"
                    :type="fieldsQi[fk].type"
                    :is-inline="true"
                    :is-required="fieldsQi[fk].isRequired"
                    :width="fieldsQi[fk].width"
                    label-width="0"
                    :label="fieldsQi[fk].label"
                    :display-label="fieldsQi[fk].displayLabel"
                    :no-label="true"
                    :options="fieldsQi[fk].options"
                    :content="formData[fieldsQi[fk].label]"
                    :handle-data-change="handleItemChange"
                  />
                  <el-button slot="reference" size="mini" type="primary" plain>人选期望</el-button>
                </el-popover>
              </div>
              <div class="form-item">
                <el-popover v-model="popperVisibleBull" placement="top" width="740" trigger="click">
                  <div v-if="showBull">
                    <el-table :data="bulletins" border :resizable="false" size="mini">
                      <el-table-column
                        v-for="head in bulletinHeads"
                        :key="head.label"
                        :prop="head.label"
                        :label="head.label"
                        :width="head.width"
                      ></el-table-column>
                    </el-table>
                  </div>
                  <el-button slot="reference" size="mini" type="primary" plain @click="loadBulletins">情报</el-button>
                </el-popover>
              </div>
            </div>
          </div>
        </div>
        <div style="min-height:2500px">
          <template v-if="displayTabs">
            <el-tabs v-model="activeTab" class="radish-detail-tabs" type="card">
              <el-tab-pane label="会谈" name="communicate">
                <div class="radish-box-content">
                  <span class="radish-btn radish-btn-primary" @click="toggleGou">旧系统沟通备注</span>
                  <div v-if="showGou">
                    <el-input
                      v-model="formData['旧系统沟通备注']"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入内容"
                      style="font-size:12px"
                    ></el-input>
                  </div>
                </div>
                <TestPaper ref="testpaper" :radish="radish"></TestPaper>
              </el-tab-pane>
              <el-tab-pane label="参与项目" name="project">
                <ProjectTable v-if="activeTab == 'project'" :radish-id="id"></ProjectTable>
              </el-tab-pane>
              <el-tab-pane label="附件" name="attch">
                <div v-if="ready" class="radish-box">
                  <div class="radish-box-content">
                    <div style="padding-bottom: 5px">
                      <el-button size="mini" round type="primary" @click="showUpload">文件上传</el-button>
                      <el-button size="mini" round type="primary" @click="showTxtUpload">粘贴上传</el-button>
                      <el-button
                        v-if="attachData && attachData.length > 0"
                        size="mini"
                        round
                        type="primary"
                        @click="showParse"
                        >解析简历</el-button
                      >
                    </div>
                    <div v-if="attachData && attachData.length > 0">
                      <FileTable
                        ref="FileTable"
                        :rid="radish._id"
                        :files="attachData"
                        :on-delete="deleteAttachment"
                        :on-mark="markAttachment"
                        :on-recommend-report="makeRecommendReport"
                        :paginate="false"
                      />
                    </div>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane label="线上简历" name="detail">
                <div v-for="(box, k) in fieldsAll" :key="k" class="radish-box">
                  <div class="radish-box-title">{{ box.title }}</div>
                  <div class="radish-box-content">
                    <template v-for="(f, fk) in box.fields">
                      <div
                        v-if="f.label == '公司'"
                        :title="`公司:${company}`"
                        class="form-item form-item-inline"
                        style="width: 32%; padding-left: 60px;"
                      >
                        <label style="width: 60px;">公司</label>
                        <el-autocomplete
                          v-model="company"
                          class="inline-input"
                          size="mini"
                          :fetch-suggestions="searchCompany"
                          placeholder="公司"
                          :trigger-on-focus="false"
                        ></el-autocomplete>
                      </div>
                      <div
                        v-else-if="f.label == '部门'"
                        :title="`部门:${department}`"
                        class="form-item form-item-inline"
                        style="width: 32%; padding-left: 60px;"
                      >
                        <label style="width: 60px;">部门</label>
                        <el-autocomplete
                          v-model="department"
                          class="inline-input"
                          size="mini"
                          :fetch-suggestions="searchDepartment"
                          placeholder="部门"
                          :trigger-on-focus="false"
                        ></el-autocomplete>
                      </div>
                      <template v-else>
                        <formItem
                          :key="fk"
                          :type="f.type"
                          :is-inline="true"
                          :is-required="f.isRequired"
                          :width="f.width"
                          :label="f.label"
                          :placeholder="f.placeholder"
                          :options="f.options"
                          :content="formData[f.label]"
                          :handle-data-change="handleItemChange"
                          :handle-focus="handleFocus"
                          :remove-tag="handleRemoveTag"
                          :handle-blur="handleBlur"
                        />
                        <div v-if="f.label == '手机' && dupData.id" :key="fk + 'd'" class="radish-dup">
                          <i class="el-icon-warning">候选人已存在:</i>&nbsp;
                          <span class="radish-link" @click="showRadish({ id: dupData.id, name: dupData['姓名'] })">
                            {{ dupData['姓名'] }}
                          </span>
                          <span>{{ (dupData['公司'] || '-') + ' ' + (dupData['部门'] || '-') }}</span>
                          <div v-if="!sending">
                            <el-button round size="mini" @click="showDiff"> 进入对比 </el-button>
                            <el-button round size="mini" @click="delOld">合并并放弃重复数据</el-button>
                            <el-button round size="mini" @click="giveUp">合并并放弃本条数据</el-button>
                          </div>
                          <div v-else>请求中...</div>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
                <div v-for="(box, k) in fieldsExp" :key="k" class="radish-box">
                  <div class="radish-box-title">{{ box.title }}</div>
                  <div class="radish-box-addbtn" @click="addExp(k)">+</div>
                  <div v-for="(c, key) in formExpData[k]" :key="key" class="radish-box-content">
                    <div class="radish-box-delbtn" @click="delExp(k, key, c)">-</div>
                    <template v-for="(f, fk) in box.fields">
                      <formItem
                        :key="fk"
                        :type="f.type"
                        :is-inline="true"
                        :is-required="f.isRequired"
                        :width="f.width"
                        :label="f.label"
                        :placeholder="f.placeholder"
                        :box="k"
                        :index="key"
                        :options="f.options"
                        :content="c[f.label]"
                        :handle-data-change="handleExpChange"
                      />
                    </template>
                  </div>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="type !== 'small'" label="操作日志" name="log">
                <logList v-if="activeTab == 'log'" :id="id" type="radish"></logList>
              </el-tab-pane>
            </el-tabs>
          </template>
          <div v-else style="font-size: 16px;line-height: 2;text-align:center"><i class="el-icon-loading"></i></div>
        </div>
      </div>
      <UploadDialog
        ref="UploadDialog"
        :type="uploadType"
        :label="attachType"
        :on-success="uploadSuccess"
      ></UploadDialog>
      <TextUploadDialog ref="TextUploadDialog" :on-success="uploadTxtSuccess" />
      <ComDepartDialog ref="ComDepartDialog" :on-confirm="handleComDepart"></ComDepartDialog>
      <el-dialog class="radish-dia" title="请选择简历" top="70px" :close-on-click-modal="false" :modal="false" :visible.sync="parseVisible">
        <div>
          <el-select v-model="currentParseMd5" filterable placeholder="请选择" style="width:100%">
            <el-option
              v-for="item in attachData"
              :key="item._id"
              :label="item.originalname"
              :value="item.md5"
            ></el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <span class="mr10"> <el-button size="mini" type="primary" @click="parseCv">解 析</el-button> </span>
          <el-button size="mini" @click="parseVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <el-dialog class="radish-dia" title="请选择附件类型" top="70px" :close-on-click-modal="false" :modal="false" :visible.sync="typeVisible">
        <div>
          <formItem
            :type="fieldAttach.type"
            :is-inline="true"
            :width="fieldAttach.width"
            :label="fieldAttach.label"
            :options="fieldAttach.options"
            content=""
            :handle-data-change="handleAttachTypeChange"
          />
        </div>
        <span slot="footer" class="dialog-footer">
          <span class="mr10"> <el-button size="mini" type="primary" @click="showUploadDia">确 定</el-button> </span>
          <el-button size="mini" @click="typeVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
    <parsePreview
      ref="parsePreview"
      :on-modify-field="onModifyField"
      :on-add-one-exp="onAddOneExp"
      :on-modify-all="onModifyAll"
    ></parsePreview>
    <DetailDiff ref="DetailDiff"></DetailDiff>
    <caseDialog ref="caseDialog" @mark="onMarkCase" @quit="onQuitCase" @change="onChangeCase"></caseDialog>
  </div>
</template>
<script>
import { ProjectTable } from '../../project'
import parsePreview from './parse-preview'
import ComDepartDialog from './dialog/company-department-dialog'
import { UploadDialog, FileTable, TextUploadDialog } from '../../file'
import { TestPaper } from '../../communicate'
import { fieldsAll, fieldsExp } from './constant/fields-add'
import { fieldsBasic, fieldsQi } from './constant/fields-detail'
import bulletinHeads from './constant/bulletin-heads'
import methodsDetail from './constant/methods-detail'
import bonusSchemes from './components/bonus-schemes'
import workExp from './components/work-exp'
import fundList from './components/fund-list-dia'
import DetailDiff from './components/detail-diff'

const dateFormat = require('dateformat')

export default {
  components: {
    UploadDialog,
    FileTable,
    TestPaper,
    parsePreview,
    bonusSchemes,
    ProjectTable,
    TextUploadDialog,
    ComDepartDialog,
    workExp,
    fundList,
    DetailDiff,
  },
  mixins: [bulletinHeads, methodsDetail],
  props: {
    id: String,
    type: String,
    pid: String,
    onClose: { type: Function, default: () => {} },
    onReady: { type: Function, default: () => {} },
  },
  data: function() {
    return {
      displayTabs: false,
      parseVisible: false,
      typeVisible: false,
      currentParseMd5: '',
      activeTab: 'communicate',
      fieldsBasic,
      fieldsQi,
      basicOrder: [],
      radish: {},
      ready: false,
      catData: [],
      prem: [],
      role: '',
      cantRemoveTag: '',
      fieldsAll,
      fieldsExp,
      fieldAttach: {
        label: '附件类型',
        type: 'select',
        width: '50%',
        options: [
          '原始简历',
          '推荐报告',
          '背景调查',
          '薪资证明',
          '测评报告',
          '会面记录',
          '名片',
          '离职资料',
          '人选offer',
          '行研报告',
          '应聘登记表',
          '其他资料',
        ],
      },
      formData: {
        地域: [],
        职能模块: [],
        细分职能: [],
        擅长方向: [],
        期望行业: [],
        期望地域: [],
        学历标签: [],
        语言标签: [],
        职业资格: [],
        香港牌照: [],
        money: {
          2023: { 月份: 12 },
          2022: { 月份: 12 },
          2021: { 月份: 12 },
          2020: { 月份: 12 },
          2019: { 月份: 12 },
          2018: { 月份: 12 },
          2017: { 月份: 12 },
        },
      },
      formExpData: {},
      years: [2023, 2022, 2021, 2020, 2019, 2018, 2017],
      attachType: '',
      uploadType: '原始简历',
      attachData: [],
      dupData: {},
      requiredFields: ['姓名'],
      isSaveShow: true,
      loading: false,
      sending: false,
      bulletins: [],
      showGou: false,
      showBull: false,
      company: '',
      department: '',
      popperVisibleExp: false,
      popperVisibleMoney: false,
      popperVisibleQi: false,
      popperVisibleBull: false,
      recommendYeji: [],
      mainFunds: [],
    }
  },
  created: function() {
    console.log(this.$route.name)
    if (this.$route.name == 'project') {
      console.log(this.$route.params.projectId)
    }
    Promise.all([this.loadData(), this.loadCate()]).then(() => {
      if (localStorage.detailbasic_sort) {
        this.basicOrder = Object.keys(JSON.parse(localStorage.detailbasic_sort))
        for (const field in this.fieldsBasic) {
          if (!this.basicOrder.includes(field)) {
            this.basicOrder.push(field)
          }
        }
      } else {
        this.basicOrder = Object.keys(this.fieldsBasic)
      }
      setTimeout(() => {
        this.displayTabs = true
      }, 0) // 优化显示性能
    })
  },
  methods: {
    handleItemChange: async function(res) {
      const { label, content } = res
      this.ready = false
      if (label == '职能模块' && content) {
        if (this.catData && this.catData.length == 0) {
          await this.loadCate()
        }
        // console.log(this.cantRemoveTag)
        // console.log(label, content, this.catData)
        const currentCat = this.catData.filter(cat => content.includes(cat['名称']))
        if (currentCat.length > 0) {
          let znArr = []
          let scArr = []
          currentCat.forEach(cat => {
            if (cat['二级职能'] && cat['二级职能'].length > 0) {
              znArr = znArr.concat(cat['二级职能'])
            }
            if (cat['擅长方向'] && cat['擅长方向'].length > 0) {
              scArr = scArr.concat(cat['擅长方向'])
            }
          })
          this.fieldsAll['基本信息'].fields['细分职能'].options = this.fieldsBasic['细分职能'].options = this.unique(
            znArr,
          )
          this.fieldsAll['基本信息'].fields['擅长方向'].options = this.fieldsBasic['擅长方向'].options = this.unique(
            scArr,
          )
          this.fieldsAll['基本信息'].fields['专业职级'].options = content && content.includes('HH-猎头') ? ['R', 'AC', 'C', 'SC', 'PC', 'TL\M', 'SM', 'AD', 'D', 'AP', 'P', 'SP', 'Office Head', 'GM', 'CEO'] : ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN']
        }
      }
      if (this.cantRemoveTag) {
        const tmp = JSON.parse(JSON.stringify(this.formData[label]))
        this.formData[label] = tmp
        this.cantRemoveTag = ''
      } else {
        this.formData[label] = content
      }
      this.ready = true
    },
    saveForm: async function(dt) {
      const tmp = Object.assign({}, dt)
      delete tmp.thirdChange
      delete tmp.thirdContent
      delete tmp.similarity
      delete tmp.thirdId
      delete tmp.createdAt
      delete tmp['部门层级']
      delete tmp['公司排名']
      delete tmp['直属部门']
      delete tmp['附件']
      delete tmp.status
      delete tmp['建议业绩']
      delete tmp['主管基金']
      delete tmp['投资案例']
      const result = await app.service('radish').modifyById({ _id: this.id, data: dt })
      return result
    },
    loadCate: async function() {
      if (!app.categories) {
        await app.getCats()
      }
      const catData = app.categories
      if (catData && catData.length > 0) {
        this.catData = catData
        const prem = app.user['SL权限']
        const role = app.user['角色']
        this.role = role
        if (!role || (!role.includes('管理员') && !role.includes('业务助理'))) {
          if (!prem || prem.length == 0) {
            this.prem = []
          } else {
            this.prem = prem.split(';')
          }
        } else {
          this.prem = []
        }
        this.fieldsAll['基本信息'].fields['职能模块'].options = this.fieldsBasic['职能模块'].options = catData.map(
          item => item['名称'],
        )
        this.fieldsAll['基本信息'].fields['行业'].options = this.fieldsBasic['行业'].options = app.industries
      }
    },
    orderBasic: function() {
      app.root.$refs.orderDialog.show({
        items: this.basicOrder,
        storageName: 'detailbasic',
        onConfirm: () => {
          if (localStorage.detailbasic_sort) {
            this.basicOrder = Object.keys(JSON.parse(localStorage.detailbasic_sort))
          }
        },
      })
    },
    onCloseWorkexp: function() {
      this.popperVisibleExp = false
    },
    makeRecommendReport() {
      app.root.$refs.reportMaker.openTemplate({ rid: this.radish._id })
    },
    showRecommendYeji: function() {
      if (this.recommendYeji.length > 0) {
        app.root.$refs.yejiDialog.show(this.radish['姓名'], this.recommendYeji)
      }
    },
    showInvestmentCase: function() {
      const r = {
        _id: this.radish._id,
        姓名: this.radish.姓名,
        投资案例: this.radish.投资案例,
        主管案例: this.radish.主管案例,
      }
      this.$refs.caseDialog.show(r)
    },
    onMarkCase(mainCase) {
      this.formData.主管案例 = mainCase
    },
    async onQuitCase() {
      const xi = this.formData.细分职能
      let arr = []
      if (!xi && !Array.isArray(xi)) {
        arr = ['退出']
      } else if (!xi.includes('退出')) {
        arr = ['退出'].concat(xi)
      }
      if (arr.length > 0) {
        const obj = { 细分职能: arr }
        const res = await app.service('radish').modifyById({ _id: this.formData._id, data: obj })
        if (res.status == 'success') {
          this.formData.细分职能 = xi
          this.$message.success('操作成功')
        }
      } else {
        this.$message.info('已经退出过')
      }
    },
    onChangeCase(tou) {
      this.formData.投资案例 = tou
      this.$message.success('操作成功')
    },
    showRadishPortrait() {
      app.root.$refs.RadishPortrait.open({ rid: this.radish._id })
    },
  },
}
</script>
<style>
.percent {
  float: left;
  line-height: 30px;
  padding-left: 10px;
}
</style>
